import { CertCatalogStatus, HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '../../models';
import { LocDisplayType } from '../../models/display-type';
import { SYSTEM_ENUM_ROOT, SYSTEM_ENUM_TYPE } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|CertCatalogStatus|`;

type SharedKeys = Pick<
	LocDef,
	'type' | 'portal' | 'displayType' | 'htmlAllowed' | 'portal' | 'shared' | 'feature'
>;

const sharedLocData: Pick<LocDef, 'displayType' | 'htmlAllowed' | 'shared' | 'feature'> = {
	displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
	htmlAllowed: false,
	shared: true,
	feature: HubFeature.Credential,
};

const sharedSpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'SP',
};

const sharedCpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'CP',
};

export type CPCertCatalogStatusLocs =
	| 'CPCertCatalogStatusEnumActive'
	| 'CPCertCatalogStatusEnumFuture'
	| 'CPCertCatalogStatusEnumRetired'
	| 'CPCertCatalogStatusEnumSunset';

export type SPCertCatalogStatusLocs =
	| 'SPCertCatalogStatusEnumActive'
	| 'SPCertCatalogStatusEnumFuture'
	| 'SPCertCatalogStatusEnumRetired'
	| 'SPCertCatalogStatusEnumSunset';

export const cpCertCatalogStatusEnumLocs: LocDefs<CPCertCatalogStatusLocs> = {
	CPCertCatalogStatusEnumActive: {
		defaultValue: 'Active',
		displayPath: `${dpRoot}Active`,
		description: `System value for 'Active' credential catalog status`,
		legacyName: 'Credential/System.Enum.CertCatalogStatus.Active',
		...sharedCpLocData,
	},
	CPCertCatalogStatusEnumFuture: {
		defaultValue: 'Future',
		displayPath: `${dpRoot}Future`,
		description: `System value for 'Future' credential catalog status`,
		legacyName: 'Credential/System.Enum.CertCatalogStatus.Future',
		...sharedCpLocData,
	},
	CPCertCatalogStatusEnumRetired: {
		defaultValue: 'Retired',
		displayPath: `${dpRoot}Retired`,
		description: `System value for 'Retired' credential catalog status`,
		legacyName: 'Credential/System.Enum.CertCatalogStatus.Retired',
		...sharedCpLocData,
	},
	CPCertCatalogStatusEnumSunset: {
		defaultValue: 'Sunset',
		displayPath: `${dpRoot}Sunset`,
		description: `System value for 'Sunset' credential catalog status`,
		legacyName: 'Credential/System.Enum.CertCatalogStatus.Sunset',
		...sharedCpLocData,
	},
};

export const spCertCatalogStatusEnumLocs: LocDefs<SPCertCatalogStatusLocs> = {
	SPCertCatalogStatusEnumActive: {
		defaultValue: 'Active',
		displayPath: `${dpRoot}Active`,
		description: `System value for 'Active' credential catalog status`,
		legacyName: 'Credential/System.Enum.CertCatalogStatus.Active',
		...sharedSpLocData,
	},
	SPCertCatalogStatusEnumFuture: {
		defaultValue: 'Future',
		displayPath: `${dpRoot}Future`,
		description: `System value for 'Future' credential catalog status`,
		legacyName: 'Credential/System.Enum.CertCatalogStatus.Future',
		...sharedSpLocData,
	},
	SPCertCatalogStatusEnumRetired: {
		defaultValue: 'Retired',
		displayPath: `${dpRoot}Retired`,
		description: `System value for 'Retired' credential catalog status`,
		legacyName: 'Credential/System.Enum.CertCatalogStatus.Retired',
		...sharedSpLocData,
	},
	SPCertCatalogStatusEnumSunset: {
		defaultValue: 'Sunset',
		displayPath: `${dpRoot}Sunset`,
		description: `System value for 'Sunset' credential catalog status`,
		legacyName: 'Credential/System.Enum.CertCatalogStatus.Sunset',
		...sharedSpLocData,
	},
};

export const CERT_CATALOG_STATUS_ENUM_LOCS = MapLocKeys<
	CPCertCatalogStatusLocs | SPCertCatalogStatusLocs
>({
	...cpCertCatalogStatusEnumLocs,
	...spCertCatalogStatusEnumLocs,
});

export type CPCertCatalogStatusEnumLocType = LocMap<CPCertCatalogStatusLocs>;
export type SPCertCatalogStatusEnumLocType = LocMap<SPCertCatalogStatusLocs>;

export const cpCertCatalogStatusKeys: {
	[key in CertCatalogStatus]: keyof CPCertCatalogStatusEnumLocType;
} = {
	Active: CERT_CATALOG_STATUS_ENUM_LOCS.CPCertCatalogStatusEnumActive,
	Future: CERT_CATALOG_STATUS_ENUM_LOCS.CPCertCatalogStatusEnumFuture,
	Retired: CERT_CATALOG_STATUS_ENUM_LOCS.CPCertCatalogStatusEnumRetired,
	Sunset: CERT_CATALOG_STATUS_ENUM_LOCS.CPCertCatalogStatusEnumSunset,
};

export const spCertCatalogStatusKeys: {
	[key in CertCatalogStatus]: keyof SPCertCatalogStatusEnumLocType;
} = {
	Active: CERT_CATALOG_STATUS_ENUM_LOCS.SPCertCatalogStatusEnumActive,
	Future: CERT_CATALOG_STATUS_ENUM_LOCS.SPCertCatalogStatusEnumFuture,
	Retired: CERT_CATALOG_STATUS_ENUM_LOCS.SPCertCatalogStatusEnumRetired,
	Sunset: CERT_CATALOG_STATUS_ENUM_LOCS.SPCertCatalogStatusEnumSunset,
};
